$(document).ready(function() {
	let $html = $('html');

	if ($html.attr('id') !== 'page-default') {
		return;
	}

	if (!$('sphere-calendar').length) {
		return;
	}

	$(document).on('click', 'sphere-calendar-event-list article a.controlPlus', function () {
		$(this).parent().parent().removeClass('perex');

		return false;
	});

	$(document).on('click', 'sphere-calendar-event-list article a.controlMinus', function () {
		$(this).parent().parent().addClass('perex');

		return false;
	});
});